import classNames from "classnames";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { siteRecaptchaKey } from 'utils/env';
import { EcommerceFlow, POSFlow } from 'utils/helper';
import CBasketItemComponent from "../CBasketItemComponent";
import { useStyles } from './style';

const CBasketComponent = ({ flowName, showSideBasket, setShowShippingLayout, setShowSideBasket }: any) => {
  const classes = useStyles();
  return (
    <GoogleReCaptchaProvider reCaptchaKey={siteRecaptchaKey}>
      {(flowName === EcommerceFlow || flowName === POSFlow) && (
        <div className={classNames(classes.basketWrapper, showSideBasket && classes.activeBasketWrapper)}>
          <p className="subHeading">Basket</p>
          <CBasketItemComponent
            flowName={flowName}
            setShowShippingLayout={setShowShippingLayout}
            setShowSideBasket={setShowSideBasket}
          />
        </div>
      )}
    </GoogleReCaptchaProvider>
  );
};

export default CBasketComponent;
